import React from "react";
import * as PropTypes from "prop-types";

export const StreamBankAutoCompleteItem = React.forwardRef((props, ref) => {
	
	const {
		className = '',
		isHighlighted = false,
		item = {},
		service = null,
		key = service?.GetPrimaryKey?.(item) ?? null,
		title = service?.GetTitle?.(item) ?? null,
		subtitle = service?.GetSubtitle?.(item) ?? null,
		icon = service?.GetIcon?.(item) ?? null,
		...remainingProps
	} = props;
	
	return <div
		className={"sb-autocomplete-item " + (isHighlighted ? "item-highlighted" : "") + ` ${className}`}
		ref={ref}
		{...remainingProps}
	>
		{icon}
		<div>
			<div className="title">{title ?? item?.name ?? 'N/A'}</div>
			{subtitle != null ? <div className="subtitle">{subtitle}</div> : null}
		</div>
	</div>;
});

StreamBankAutoCompleteItem.propTypes = {
	className: PropTypes.string,
	isHighlighted: PropTypes.any,
	item: PropTypes.any
};
